import bus from "../bus";
import { playerEvents } from "../player/events";

/**
 * Trigger live stream when button is clicked
 *
 * @param  {Element} el   Trigger element
 * @return {Void}
 */

export default function triggerLiveStream(el, props) {
  // Start the stream
  el.addEventListener("click", function(e) {
    bus.emit(playerEvents.PLAY_DEFAULT_STREAM);
    bus.emit(playerEvents.PLAY);
  });
}
